import "./SelfCollectionCard.css";
import phone from "../../../../Assets/Icons/phone.png";
import address from "../../../../Assets/Icons/location-pin.png"
import email from "../../../../Assets/Icons/mail.png";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const SelfCollectionCard = ({ userCartData, dataOfSwitchToSelfCollection }) => {
    const [showThisComponent, setShowThisComponent] = useState(false);
    const [hasCollectionOnly, setHasCollectionOnly] = useState(false);
    const [filteredItems, setFilteredItems] = useState(false);

    useEffect(() => {
        if (dataOfSwitchToSelfCollection?.length > 0) {
            setShowThisComponent(dataOfSwitchToSelfCollection.some(items => items.active === true));
        }
    }, [dataOfSwitchToSelfCollection]);

    useEffect(() => {
        if (userCartData?.length > 0) {
            const isCollectionOnlyItemPresent = userCartData
                .flatMap(cart => cart.subOrders || [])
                .flatMap(subOrder => subOrder.itemDetails || [])
                .some(item => item.isCollectionOnly === true);

            setHasCollectionOnly(isCollectionOnlyItemPresent);
        }
    }, [userCartData]);

    useEffect(() => {
        if (userCartData?.length > 0) {
            const filtered = userCartData
                .map(cart => ({
                    ...cart,
                    subOrders: cart.subOrders.map(subOrder => ({
                        ...subOrder,
                        itemDetails: subOrder.itemDetails.filter(item => item.isCollectionOnly !== true)
                    })).filter(subOrder => subOrder.itemDetails.length > 0)
                }))
                .filter(cart => cart.subOrders.length > 0);

            setFilteredItems(filtered);
        }
    }, [userCartData]);

    return (
        <div style={{ display: showThisComponent || hasCollectionOnly ? "" : "none" }} className="checkOutCard mt-4">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between">
                        <div>
                            <h4 className="fw-bold pb-4">
                                Self-Collection
                            </h4>
                        </div>
                    </div>

                    <div className="deliveryDetails">
                        <div className="d-flex locaionDetails">
                            {/* <div className='d-flex align-items-start'>
                              <img
                                src={locationIcon}
                                alt=''
                                style={{ width: '1.5rem' }}
                              />
                            </div> */}
                            <div className="d-flex flex-column addressCheckOut">
                                <h5 className="text-black-50">
                                    Restaurant Addresses
                                </h5>
                                <div className="AddressCard">
                                    <div className="scrollable-addresses">
                                        <div
                                            className="scrollable-container"
                                            style={{
                                                maxHeight: "300px",

                                                // overflowY: 'auto',
                                            }}
                                        >
                                            {userCartData?.map((cart, index) => {
                                                const collectionItems = cart.subOrders
                                                    .flatMap(subOrder => subOrder.itemDetails)
                                                    .filter(item => item.isCollectionOnly === true);

                                                if (collectionItems.length === 0) return null;

                                                return (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            margin: "0",
                                                            // border:
                                                            //     selectedAddressId ===
                                                            //         address.id
                                                            //         ? // address.isDefault
                                                            //         "2px solid black"
                                                            //         : "none",
                                                        }}
                                                        className="checkOutCard m-2 d-flex"
                                                    // onClick={() => {
                                                    //     handleAddressSelect(address.id);
                                                    //     changeDeliveryAddress(address);
                                                    // }}
                                                    >
                                                        <div className="restaurant-logo-container">
                                                            <img
                                                                src={cart.restaurantLogo}
                                                                alt={cart.restaurantName}
                                                            />
                                                        </div>
                                                        <div className="ps-2">
                                                            {/* <div>
                                                    <h5>Work</h5>
                                                  </div> */}
                                                            <div>
                                                                <Link className="self-restaurant-name" to={`/${cart.urlName}`}>{cart.restaurantName}</Link>
                                                            </div>
                                                            {/* <div>
                                                            <h5>
                                                                <Badge pill bg="info">
                                                                    {address.tag}
                                                                </Badge>
                                                            </h5>
                                                        </div> */}
                                                            <div className="d-flex align-items-start">
                                                                <div className="self-collection-icon me-1">
                                                                    <img src={address} alt="address icon" />
                                                                </div>
                                                                <p className="self-restaurant-info">
                                                                    Address:{" "}
                                                                    {cart.addressLine1}
                                                                </p>
                                                            </div>
                                                            <div className="d-flex align-items-start">
                                                                <div className="self-collection-icon me-1">
                                                                    <img src={email} alt="email icon" />
                                                                </div>
                                                                <p className="self-restaurant-info">
                                                                    Email:{" "}
                                                                    {cart.emailAddress}
                                                                </p>
                                                            </div>
                                                            <div className="d-flex align-items-start">
                                                                <div className="self-collection-icon me-1">
                                                                    <img src={phone} alt="phone icon" />
                                                                </div>
                                                                <p className="self-restaurant-info">
                                                                    Phone:{" "}
                                                                    {cart.phoneNumber}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {/* <div
                                                        className="d-flex flex-row gap-2"
                                                        style={{ marginLeft: "auto" }}
                                                    >
                                                        <div
                                                            className="flex-grow-1"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCloseUpdateModal(
                                                                    address
                                                                );
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={EditIcon}
                                                                alt=""
                                                                style={{ width: "1.4rem" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="flex-grow-1"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteAddress(
                                                                    address.id
                                                                );
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={DeleteIcon}
                                                                alt=""
                                                                style={{ width: "1.5rem" }}
                                                            />
                                                        </div>
                                                        {!address.isDefault && (
                                                            <Dropdown className="flex-grow-1 ">
                                                                <Dropdown.Toggle
                                                                    variant="success"
                                                                    id="dropdown-basic"
                                                                    className="d-flex bg-transparent border-0"
                                                                >
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            handleUpdateDefaultAddress(
                                                                                address.id,
                                                                                address.userId
                                                                            )
                                                                        }
                                                                    >
                                                                        Set as default
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        )}
                                                    </div> */}
                                                    </div>
                                                )
                                            })}

                                            {Array.isArray(dataOfSwitchToSelfCollection) &&
                                                userCartData?.map((cart, index) => {
                                                    const collectionItems = cart?.subOrders
                                                        .filter(subOrders => dataOfSwitchToSelfCollection.some(item => item.subOrderId === subOrders.subOrderId && item.active === true))
                                                        .flatMap(subOrder => subOrder?.itemDetails || []);

                                                    if (collectionItems.length === 0) return null;

                                                    return (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                margin: "0",
                                                            }}
                                                            className="checkOutCard m-2 d-flex"
                                                        >
                                                            <div className="restaurant-logo-container">
                                                                <img
                                                                    src={cart.restaurantLogo}
                                                                    alt={cart.restaurantName}
                                                                />
                                                            </div>
                                                            <div className="ps-2">
                                                                <div>
                                                                    <Link className="self-restaurant-name" to={`/${cart.urlName}`}>{cart.restaurantName}</Link>
                                                                </div>
                                                                <div className="d-flex align-items-start">
                                                                    <div className="self-collection-icon me-1">
                                                                        <img src={address} alt="address icon" />
                                                                    </div>
                                                                    <p className="self-restaurant-info">
                                                                        Address:{" "}
                                                                        {cart.addressLine1}
                                                                    </p>
                                                                </div>
                                                                <div className="d-flex align-items-start">
                                                                    <div className="self-collection-icon me-1">
                                                                        <img src={email} alt="email icon" />
                                                                    </div>
                                                                    <p className="self-restaurant-info">
                                                                        Email:{" "}
                                                                        {cart.emailAddress}
                                                                    </p>
                                                                </div>
                                                                <div className="d-flex align-items-start">
                                                                    <div className="self-collection-icon me-1">
                                                                        <img src={phone} alt="phone icon" />
                                                                    </div>
                                                                    <p className="self-restaurant-info">
                                                                        Phone:{" "}
                                                                        {cart.phoneNumber}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                            {/* {showAddressError && (
                                                <p className="text-danger ps-2 pt-2">
                                                    Please select or provide an
                                                    address
                                                </p>
                                            )} */}
                                        </div>
                                    </div>
                                    {/* <h5 style={{ padding: '0', margin: '0' }}>
                                 
                                </h5>
                                <h6
                                  className="city"
                                  style={{ padding: "0", margin: "0" }}
                                >
                                  UK
                                </h6> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SelfCollectionCard;